module.exports = __webpack_public_path__ + "img/fcc-cost-comparison-graph-screen.72d1a33d.png";